import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
} from '@mui/material';
import PublicIcon from '@mui/icons-material/Public';
import AddIcon from '@mui/icons-material/Add';

/**
 * List Addition Request Dialog Component
 * Confirmation dialog for adding parameter to public list
 *
 * @param {boolean} open - Whether dialog is open
 * @param {Function} onClose - Handler for closing dialog
 * @param {Object} list - List to add parameter to
 * @param {number} parameterId - Parameter ID to add
 * @param {Function} onConfirm - Handler for confirming addition request
 */
const ListAddRequestDialog = ({
  open,
  onClose,
  list,
  parameterId,
  onConfirm,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <PublicIcon />
          Parameter zu öffentlicher Liste hinzufügen
        </Box>
      </DialogTitle>
      <DialogContent>
        {list && (
          <>
            <Alert severity="info" sx={{ mb: 2 }}>
              <Typography variant="body2">
                <strong>Öffentliche Liste:</strong> Ihre Anfrage wird an die Listen-Verwalter gesendet und muss genehmigt werden.
              </Typography>
            </Alert>

            <Paper variant="outlined" sx={{ p: 2 }}>
              <Typography variant="subtitle2" gutterBottom>
                Listen-Information:
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <PublicIcon fontSize="small" color="primary" />
                <Typography variant="body1" fontWeight="bold">
                  {list.name}
                </Typography>
              </Box>
              <Typography variant="caption" color="textSecondary" display="block">
                Erstellt von: {list.createdBy}
              </Typography>
              <Typography variant="caption" color="textSecondary" display="block">
                Aktuelle Parameter: {list.parameterIds.length}
              </Typography>
            </Paper>

            <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
              Möchten Sie die Aufnahme dieses Parameters in diese öffentliche Liste vorschlagen?
            </Typography>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          Abbrechen
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          startIcon={<AddIcon />}
        >
          Vorschlag senden
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ListAddRequestDialog;
